import { HttpUtil } from "@/lib/HttpUtil";
import { StaffResponse } from "@/models/CaseModal";

export class StaffApi {
    httpUtil = new HttpUtil();
    getStaffDetails(searchText: string, searchType: string): Promise<StaffResponse[]> {
        return this.httpUtil.get<StaffResponse[]>(`staff/list?searchText=${searchText}&type=${searchType}`, { CancelToken: "StaffApi.getInmateDetails" });
    }
}